import { useEffect, useState } from 'react';
import { Card, Avatar, Text, Group, Button, Badge, Image, Box, Skeleton } from '@mantine/core';

interface Artist {
  id: number;
  name: string;
  slug: string;
  description?: string;
  avatar_url?: string;
  instructor?: boolean;
  dj?: boolean;
  [key: string]: any;
}

interface ArtistCardProps {
  artist: Artist;
  onCardClick?: (artist: Artist) => void;
}

export default function ArtistCard({ artist, onCardClick }: ArtistCardProps) {
  const [imageLoaded, setImageLoaded] = useState(false);

  // Extract the first 100 characters of the description and strip HTML tags
  const getPlainTextDescription = (html?: string) => {
    if (!html) return '';

    // Create a temporary element to strip HTML tags
    const tempElement = document.createElement('div');
    tempElement.innerHTML = html;
    const plainText = tempElement.textContent || tempElement.innerText || '';

    return plainText.length > 100 ? plainText.substring(0, 100) + '...' : plainText;
  };

  const plainDescription = getPlainTextDescription(artist.description);

  // Handle card click
  const handleCardClick = (e: React.MouseEvent) => {
    console.log('Passing artist to drawer:', artist);
    // If clicking on a link or button inside the card, don't trigger the drawer
    if ((e.target as HTMLElement).closest('a') || (e.target as HTMLElement).closest('button')) {
      return;
    }

    // Prevent default behavior
    e.preventDefault();
    e.stopPropagation();

    // Call the parent's onCardClick if provided
    if (onCardClick) {
      onCardClick(artist); // FIXED: Pass artist object instead of event
    }
  };

  return (
    <Card
      shadow="sm"
      padding={0}
      radius="md"
      withBorder
      style={{
        height: '100%',
        width: '100%', // Make it take full width of its Grid.Col parent
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
        backgroundColor: '#fff7ed1a',
        border: '1px solid #f2f2f230',
        cursor: onCardClick ? 'pointer' : 'default',
      }}
      onClick={handleCardClick}
    >
      <Card.Section style={{ position: 'relative', paddingBottom: '100%', height: 0, overflow: 'hidden' }}>
        {!imageLoaded && <Skeleton height={500} width={500} animate={true} />}
        <Image
          src={artist.avatar_url}
          alt={artist.name}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
      </Card.Section>
      <Box style={{ color: '#FFF7ED', padding: '0px 12px' }}>
        <Text size="lg" fw={500} style={{ color: '#FFF7ED', lineHeight: 1 }} mt="md">
          {artist.name}
        </Text>

        <Group gap="xs" mb="md" mt="xs">
          {artist.instructor && (
            <Badge
              color="#EA580C"
              variant="default"
              size="lg"
              styles={{
                root: {
                  textTransform: 'none',
                },
              }}
            >
              Instructor
            </Badge>
          )}
          {artist.dj && (
            <Badge
              color="#EA580C"
              variant="default"
              size="lg"
              styles={{
                root: {
                  textTransform: 'none',
                },
              }}
            >
              DJ
            </Badge>
          )}
        </Group>
      </Box>
    </Card>
  );
}
